import { render, staticRenderFns } from "./PublicoAlvo.vue?vue&type=template&id=0b7a3986&scoped=true"
import script from "./PublicoAlvo.vue?vue&type=script&lang=js"
export * from "./PublicoAlvo.vue?vue&type=script&lang=js"
import style0 from "./PublicoAlvo.vue?vue&type=style&index=0&id=0b7a3986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a3986",
  null
  
)

export default component.exports